import api from "@/config/api"
import { withLoading } from "@/store/helpers"

export default {
  namespaced: true,
  state: () => ({
    reminders: {},
    loading: false,
  }),
  mutations: {
    setReminders(state, payload) {
      state.reminders = payload
    },
    setLoading(state, loading) {
      state.loading = loading
    }
  },
  actions: {
    async fetchReminders(context) {
      return withLoading(async () => {
        const response = await api.get("/reminders")
        context.commit("setReminders", response.data)
        return response.data
      }, context)
    },

   
    async createReminder(context, params) {
      return withLoading(async () => {
        const response = await api.post("/reminders", params)
        context.commit("setReminders", response.data)
      }, context)
    },

    async updateReminder(context, { id, ...params }) {
      return withLoading(async () => {
        const response = await api.put(`/reminders/${id}`, params)
        context.commit("setReminders", response.data)
      }, context)
    },

    async deleteReminder(context, id) {
      return withLoading(async () => {
        const response = await api.delete(`/reminders/${id}`)
        context.commit("setReminders", response.data)
      }, context)
    }
  }
}